import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <>
            {/* ============================ Footer Start ================================== */}
            <footer className="light-footer">
                <div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-3">
                                <div className="footer-widget">
                                    <img src="assets/img/ncc_logo2.png" className="img-footer" alt="National Computer Classes Logo" />
                                    <div className="footer-add">
                                        <p>2nd Floor, Star Complex, Near Canara Bank, Chomu, Jaipur, Rajasthan, India 303702</p>
                                        <p>+91-9785012301</p>
                                        <p>nationalcomputer11024@gmail.com</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="footer-widget">
                                    <h4 className="widget-title">Navigation</h4>
                                    <ul className="footer-menu">
                                        <li>
                                            <Link to={"/about"}>About Us</Link>
                                        </li>
                                        <li>
                                            <Link to={"/course"}>Courses</Link>
                                        </li>
                                        <li>
                                            <Link to={"/gallery"}>Gallery</Link>
                                        </li>
                                        <li>
                                            <Link to={"/contact"}>Contact</Link>
                                        </li>
                                        <li>
                                            <Link to={"#"}>Blog</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="footer-widget">
                                    <h4 className="widget-title">Our Courses</h4>
                                    <ul className="footer-menu">
                                        <li>
                                            <a href="#">Web Design</a>
                                        </li>
                                        <li>
                                            <a href="#">Web Development</a>
                                        </li>
                                        <li>
                                            <a href="#">App Design</a>
                                        </li>
                                        <li>
                                            <a href="#">Graphic Design</a>
                                        </li>
                                        <li>
                                            <a href="#">Accounting (Tally)</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="footer-widget">
                                    <h4 className="widget-title">Help &amp; Support</h4>
                                    <ul className="footer-menu">
                                        <li>
                                            <a href="#">Documentation</a>
                                        </li>
                                        <li>
                                            <a href="#">Live Chat</a>
                                        </li>
                                        <li>
                                            <a href="#">Mail Us</a>
                                        </li>
                                        <li>
                                            <a href="#">Privacy</a>
                                        </li>
                                        <li>
                                            <a href="#">FAQs</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12">
                                <div className="footer-widget">
                                    <h4 className="widget-title">Download Apps</h4>
                                    <a href="#" className="other-store-link">
                                        <div className="other-store-app">
                                            <div className="os-app-icon">
                                                <i className="lni-playstore theme-cl" />
                                            </div>
                                            <div className="os-app-caps">
                                                Google Play
                                                <span>Get It Now</span>
                                            </div>
                                        </div>
                                    </a>
                                    <a href="#" className="other-store-link">
                                        <div className="other-store-app">
                                            <div className="os-app-icon">
                                                <i className="lni-apple theme-cl" />
                                            </div>
                                            <div className="os-app-caps">
                                                App Store
                                                <span>Now Available</span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <p className="mb-0">
                                    © 2024 National Computer Classes. Designed by{" "}
                                    <a href="https://nationalsoftinfotech.com/web/index">National Soft Infotech</a>.
                                </p>
                            </div>
                            <div className="col-lg-6 col-md-6 text-right">
                                <ul className="footer-bottom-social">
                                    <li>
                                        <a href="#">
                                            <i className="ti-facebook" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i className="ti-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i className="ti-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i className="ti-linkedin" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            {/* ============================ Footer End ================================== */}
        </>

    )
}
